import BaseObject from '../../../../base/base_object';
import Model from './geo_hybrid_model';
import {SERIVCES_FUNC_LIST, FEATURE_CB_FUNC} from '../../native/native_const';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import {GEO} from './geo_hybrid_consts';
import Store from "../../../../utils/store";
import {
    GeoLocationReason
} from "../../../../../../app-react/services/geo-location/strategies/geo-location.strategy.interface";


/**
 *
 *
 */
class Geo extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Geo';

    _model = null;
    _HybridService = null;
    _isFeatureEnable = false;
    _isPermissionPopupSupported = false;


    init(params) {

        super.init();

        this._model = Model.create(params);

        this._subscribe();
    }


    _subscribe() {
        Event.on(SYSTEM_EVENTS.GEO_HYBRID_UPDATE_ENABLE, this._updateEnable, this);
        Event.on(SYSTEM_EVENTS.GEO_HYBRID_GT_CB, this.onHybridDirectCall, this);
    }

    _updateEnable(val){

        if(null !== this._HybridService){

            this._isFeatureEnable = val;

            if(this._isFeatureEnable) {
                Event.on(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION, this._onGetGeoLocation, this);
                this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.GEO_SET_CB, FEATURE_CB_FUNC.HYBRID_GEO_CALL);
            }
        }
    }

    _onGetGeoLocation(data){

        let bValid = this._isFeatureEnable && this._model.isValidData(data);

        if(bValid) {
            const isPeriodic = GeoLocationReason.Periodic === data['reason'];
            data[GEO.GEO_CB_RES] = 'onGeoLocationRes';
            this._getGeoLocation(data, isPeriodic);
        }

        return bValid;
    }

    _getSessionId(geoparams){

        const isLogin = GeoLocationReason.Login === geoparams['reason'];

        if(isLogin){
            let oAuth2Service = this._HybridService.serviceFactory.oAuth2Service();
            if(oAuth2Service) {
                geoparams[GEO.GEO_SESSION_ID] = oAuth2Service.isAuthorized() ? oAuth2Service.getToken().sessionId : '';
            }
        }

        return geoparams;
    }

    _getGeoLocation(geoparams, isPeriodic){

        geoparams = this._getSessionId(geoparams);

        if(this._isPermissionPopupSupported){
            this._sendElasticEvent('getGeoLocation', 'new hybrid flow');
            this._getGeoLocationFromHybrid(geoparams, isPeriodic);
        }else{
            this._sendElasticEvent('getGeoLocation', 'old hybrid flow');
            this._HybridService.getGeoLocation(geoparams);//support old hybrids
        }
    }

    _getGeoLocationFromHybrid(geoparams, isPeriodic){

        this._showGeoOrbitMsg(isPeriodic).then( ()=> {
            this._sendElasticEvent('getGeoLocationFromHybrid', 'showGeoLocationPermissionPopUp');
            this._HybridService.showGeoLocationPermissionPopUp().then(data => {
                this._sendElasticEvent('getGeoLocationFromHybrid', 'getGeoLocation', JSON.stringify(geoparams));
                this._HybridService.getGeoLocation(geoparams);
            });
        });
    }


    onHybridDirectCall(data) {
        this._executeFunc(data);
    }

    _executeFunc(data) {
        let fn = this._model.getFuncName(data);

        if('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    onGeoLocationRes(data) {
        try{
            this._sendElasticEvent('onGeoLocationRes', 'geoResponse', JSON.stringify(data));
        }catch(e){
            this._sendElasticEvent('onGeoLocationRes', 'geoResponse','X');
        }

        let allData = this._model.geoLocationRes(data);
        Event.fire(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION_RES, allData);
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        this._HybridService.isPermissionPopupSupported().then(data => {
            this._isPermissionPopupSupported = true;
        });

        return this;
    }

    _sendElasticEvent(action, label, value){
        const dataToSend  = {
            CGPEventCategory: 'hybrid_geo_feature',
            CGPEventAction: action,
            CGPEventLabel: label,
            CGPEventValue: value
        };
        this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();
    }


    _showGeoOrbitMsg(isPeriodic){
        return new Promise((resolve, reject) => {
            const GEO_PERMISSION = 'permisions-popup';
            if(isPeriodic || Store.get(GEO_PERMISSION)) {
                return resolve();
            }
            this._sendElasticEvent('onGeoLocation', 'show geo permission popup');

            return this._HybridService.serviceFactory.orbitComponentRenderService().showGeoPermissionPopup({
                onOkPressed: ()=> {
                    Store.set(GEO_PERMISSION, true);
                    return resolve();
                },
                onMessageClosed: ()=> {
                    return resolve();
                }
            });
        });
    }
}

export default Geo;
